import { render, staticRenderFns } from "./ItemRemarkGroup.vue?vue&type=template&id=a9a00ebe"
import script from "./ItemRemarkGroup.vue?vue&type=script&lang=js"
export * from "./ItemRemarkGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports